<template lang="html">
    <!-- the navigation drawer (aside), basics fonctionnality -- called with bus and filled with an other component  -->
    <v-navigation-drawer
        fixed right light hide-overlay touchless stateless class="app-aside"
        v-model="isOpen" :permanent="isOpen">

        <template v-if="currentView != null">

            <v-list class="head">
                <v-list-tile class="li">
                    <v-list-tile-title>
                        <v-icon v-if="currentView.data().icon">{{ currentView.data().icon }}</v-icon>
                        {{ currentView.data().title }}
                    </v-list-tile-title>

                    <v-btn icon @click.stop="$eventHub.$emit('close-aside')">
                      <v-icon>close</v-icon>
                    </v-btn>
                </v-list-tile>
            </v-list>

            <component :is="currentView" :params="params" ref="currentView"></component>

        </template>

    </v-navigation-drawer>
</template>

<script>
    export default {
        data() {
            return {
                isOpen:         false,
                currentView:    null,
                params:         null
            }
        },
        created() {
            // when called, we open the aisde, and fill the content of this one with the component given
            this.$eventHub.$on('open-aside', (component,params) => {
                if (this.isOpen && this.currentView == component) {
                    this.isOpen         = false;
                } else {
                    this.isOpen         = true;
                    this.currentView    = component;
                    this.params         = params;
                }
            })

            this.$eventHub.$on('close-aside', () => {
                this.currentView =null;
                this.params    = null;
                this.isOpen = false
            })
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'
    .app-aside {
        overflow: hidden
        margin-top: $app-header-height !important
        width: 37rem !important
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px
        font-weight: 600
        box-shadow: 6px 21px 52px 0px #EBEFF5
        transform: translateX(500px)!important
        &.navigation-drawer--open {
            transform: translateX(0px)!important
        }

        & >>> .navigation-drawer__border {
            display: none
        }

      .head {
        background-color: $primary-color
        height: $app-header-height

        .list__tile__title {
          display: flex
          align-items: center
          color: #FFF
          font-weight: 700

          & >>> i.icon {
            color: #FFF !important
            margin-right: 2.5rem
          }
        }

        .btn, .btn__content{
          & >>> i.icon {
            color: #FFF !important
          }
        }
        .btn--icon {
          min-width: 36px
        }
      }
    }

</style>



// WEBPACK FOOTER //
// src/layouts/app/Aside.vue